import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {YearService} from './shared-components/year/year.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private yearService: YearService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // Get the auth token from the service.
        let changedReq = req;

        // Adding authorization headers
        const authToken = sessionStorage.getItem('accessToken');
        let siteId: number;
        let yearId: number;
        if (this.yearService.defaultYear) {
            siteId = this.yearService.defaultYear.SchoolID;
            yearId = this.yearService.defaultYear.Id;
        } else {
            siteId = -1;
            yearId = -1;
        }
        if (authToken) {
            const newheader  = 'Bearer ' + authToken.toString();
            changedReq = req.clone(
                {
                    setHeaders: {
                        Authorization: newheader.toString(),
                        'SiteId': siteId.toString(),
                        'YearId': yearId.toString()
                    }
                }
            );
        }

        // Handling the request with authorization
        return next.handle(changedReq);
    }
}


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
